import { render, staticRenderFns } from "./form-of-modal.vue?vue&type=template&id=296f1705&scoped=true"
import script from "./form-of-modal.vue?vue&type=script&lang=js"
export * from "./form-of-modal.vue?vue&type=script&lang=js"
import style0 from "./form-of-modal.vue?vue&type=style&index=0&id=296f1705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f1705",
  null
  
)

export default component.exports